import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'selected-component';
export function useSendSelectedComponent() {
    const { postMessage } = useIframeMessageContext();
    const sendSelectedComponent = useCallback((component) => {
        postMessage(MESSAGE_TYPE, component);
    }, [postMessage]);
    return { sendSelectedComponent };
}
const handleMessage = (context, message) => {
    const { setSelectedComponent, setConfigureComponent } = context;
    setSelectedComponent(message.body, { shouldSendIframe: false });
    setConfigureComponent(message.body);
};
registerIframeMessageHook(MESSAGE_TYPE, useSendSelectedComponent, handleMessage);
//# sourceMappingURL=useSendSelectedComponent.js.map